import { createSlice } from "@reduxjs/toolkit";
import { LocalStorageKeys } from "../core";

const initialState = {
  isLoggedIn: localStorage.getItem(LocalStorageKeys.adminToken) ? true : false,
  admin: null,
  token: localStorage.getItem(LocalStorageKeys.adminToken),
  isLoading: false,
  profile: null,

};

const adminReducerSlice = createSlice({
  name: "admins",
  initialState,
  reducers: {
    changeLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },
    setAdmin: (state, action) => {
      state.admin = action.payload;
    },
    setAdminLogin: (state, action) => {
      state.isLoggedIn = true;
      state.isLoading = false;
      localStorage.setItem(LocalStorageKeys.adminToken, action.payload);
    },
    setAdminLogout: (state) => {
      localStorage.removeItem(LocalStorageKeys.adminToken);
      state = {
        isLoggedIn: false,
        admin: null,
        token: null,
      };
    },
    setAdminProfile: (state, action) => {
      state.profile = action.payload;
      state.isLoading = false;
    },
   
  },
});

export const { setAdmin, setAdminLogin, setAdminLogout,changeLoadingState,setAdminProfile } =
  adminReducerSlice.actions;

export default adminReducerSlice.reducer;
